import { DocumentData } from "./documents";
import { SuccessPaginationResponseType, SuccessResponseType } from "./main";

export enum ReportType {
    FORM1 = 1,
    FORM2 = 2,
    FORM3 = 3,
    FORM4 = 4,
}

export enum ReportState {
    EDIT = 0,
    MODERATION = 1,
    REJECT = 2,
    ACTIVE = 4,
}

export interface ReportDateSearch {
    from?: string;
    report_type?: string;
}

export interface ReportControlPointCreate {
    report_type: string;
    expired_at: string;
    name: string;
    description: string;
}

export interface ReportControlPointData {
    id: number;
    name: string | null;
    description: string | null;
    expired_at: string;
    report_type: number;
    created_at: string;
    updated_at: string;
}

export interface ReportSearch extends ReportDateSearch {
    state?: string;
}

export interface ReportCreate {
    report_date_id: number | null;
    document_id?: number | null;
    status?: {
        state: number | null;
        message: string;
    };
    info?: any;
}

interface Center {
    id: number;
    name: string;
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
    chief_work_position: string;
    chief_name: string;
    phone: string | null;
    email: string | null;
    links: string[];
}

interface ReportDate {
    id: number;
    name: string | null;
    description: string | null;
    expired_at: string;
    report_type: number;
    created_at: string;
    updated_at: string;
}

interface Info extends Record<string, unknown> {}

interface Status {
    state: number;
    message: string;
    created_at: string;
    moderateable_id: number;
    moderateable_type: string;
}

export interface ReportData {
    id: number;
    info: Info;
    state: number;
    status?: Status;
    report_date_id: number;
    center_id: number;
    document_id: number | null;
    created_at: string;
    updated_at: string;
    center: Center;
    // уточнить что возвращает поле
    document: DocumentData[] | null;
    report_date: ReportDate;
}

export interface ReportControlPointSuccessResponse
    extends SuccessPaginationResponseType<Array<ReportControlPointData>> {}

export interface ReportsSuccessResponse extends SuccessPaginationResponseType<Array<ReportData>> {}

export interface ReportSuccessResponse extends SuccessResponseType<ReportData> {}
